export default __webpack_public_path__ + "static/media/placehoplder_image.440f2ace.svg";